import axios from "axios";
import { config } from "@/config/constants.js";
import jsonToFormData from "@ajoelp/json-to-formdata";
let fileDownload = require("js-file-download");
export default {
  namespaced: true,
  state: {
    endpoint: "",
    status: "",
    loading_percent: 0,
    selected_rows: [],
    header: [
      { text: "ID", value: "id" },
      { text: "Name", value: "name" },
      { text: "Actions", value: "actions", sortable: false },
    ],
    list: [],
    page: 1,
    total: 0,
    options: {
      itemsPerPage: 10,
      search: "",
    },
    customerrors: [],
  },
  mutations: {
    request(state) {
      state.status = "loading";
    },
    success(state, data) {
      state.status = "success";

      // Si trae list, úsalo. Si trae un array directo, úsalo.
      if (data && Array.isArray(data.list)) {
        state.list = data.list;
      } else if (Array.isArray(data)) {
        state.list = data;
      } else if (data && Array.isArray(data.data)) {
        state.list = data.data;
      }

      // Total
      if (data && data.total !== undefined && data.total !== null) {
        state.total = data.total;
      }
    },
    error(state) {
      state.status = "error";
    },
    customerrors(state, data) {
      state.customerrors = data["customerrors"];
    },
    options(state, data) {
      state.options = data;
    },
    loading_percent(state, data) {
      state.loading_percent = data;
    },
    setSelectedRows(state, rows) {
      state.selected_rows = rows;
    },
    setTotal(state, { value }) {
      state.total = value;
    }
  },
  actions: {
    getList({ commit, state }, options) {
      return new Promise((resolve, reject) => {
        commit("request");

        let filter = {
          search: "",
          limit: 10,
          page: 1,
        };

        if (options) {
          for (let i in options) {
            filter[i] = options[i];
          }

          commit("options", options);
          filter["limit"] =
            options.itemsPerPage === -1 ? state.total : options.itemsPerPage;
          filter["page"] = options.page;
          filter["search"] = options.search;
          filter["sorting_column"] =
            options.sortBy.length > 0 ? options.sortBy[0] : "";
          filter["sorting_order"] =
            options.sortDesc.length > 0
              ? options.sortDesc[0]
                ? "asc"
                : "desc"
              : "";
        }

        axios
          .get(config.api_url + state.endpoint, { params: filter })
          .then((response) => {
            commit("success", {
              list: response.data,
              total: parseInt(response.headers["pagination-count"]),
            });
            resolve(response.data);
          })
          .catch((err) => {
            commit("error");
            reject(err);
          });
      });
    },
    getListAll({ commit, state }, options) {
      return new Promise((resolve, reject) => {
        commit("request");
        commit("loading_percent", 0);
        let filter = {
          search: "",
        };

        if (options) {
          filter = {
            ...options,
            search: options.search || "",
          };
        }

        axios
          .get(config.api_url + state.endpoint, {
            params: filter,
            onDownloadProgress: (progressEvent) => {
              const totalLength = progressEvent.total;
              if (totalLength) {
                const percent = Math.round(
                  (progressEvent.loaded * 100) / totalLength
                );
                commit("loading_percent", percent);
              }
            },
          })
          .then((response) => {
            commit("success", {
              list: response.data,
              total: parseInt(response.headers["pagination-count"]),
            });
            resolve(response.data);
          })
          .catch((err) => {
            commit("error");
            reject(err);
          });
      });
    },
    getApiExport({ commit, state }, data) {
      data["sorting_column"] =
        data.sortBy && data.sortBy.length > 0 ? data.sortBy[0] : "";
      data["sorting_order"] =
        data.sortDesc && data.sortDesc.length > 0
          ? data.sortDesc[0]
            ? "asc"
            : "desc"
          : "";

      return new Promise((resolve, reject) => {
        commit("request");
        axios
          .get(config.api_url + state.endpoint, {
            params: { ...data, format: "xlsx" },
          })
          .then((response) => {
            commit("success");

            const a = document.createElement("a");
            a.style.display = "none";
            a.href = response.data;
            a.download = response.headers.filename;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            resolve(response.data);
          })
          .catch((err) => {
            commit("error");
            reject(err);
          });
      });
    },
    create({ commit, state }, data) {
      state.customerrors = [];
      let saveData = {};
      saveData[state.object] = data;
      return new Promise((resolve, reject) => {
        commit("request");
        const formData = jsonToFormData(saveData, {
          arrayIndexes: true,
          excludeNull: true,
        });
        axios
          .post(config.api_url + state.endpoint, formData)
          .then((response) => {
            commit("success");
            resolve(response.data);
          })
          .catch((error) => {
            commit("error");
            /* commit("customerrors", {
              customerrors: error.response.data,
            }); */
            reject(error.response.data);
          });
      });
    },
    update({ commit, state }, data) {
      state.customerrors = [];
      let saveData = {};
      saveData[state.object] = data;
      return new Promise((resolve, reject) => {
        commit("request");
        const formData = jsonToFormData(saveData, {
          arrayIndexes: true,
          excludeNull: true,
        });
        axios
          .put(config.api_url + state.endpoint + "/" + data.id, formData)
          .then((response) => {
            commit("success");
            resolve(response.data);
          })
          .catch((error) => {
            commit("error");
            commit("customerrors", {
              customerrors: error.response.data,
            });
            reject(error.response.data);
          });
      });
    },
    delete({ commit, state }, data) {
      return new Promise((resolve, reject) => {
        commit("request");
        axios
          .delete(config.api_url + state.endpoint + "/" + data.id)
          .then(() => {
            commit("success");
            resolve();
          })
          .catch((error) => {
            commit("error");
            reject(error.response.data);
          });
      });
    },
    delete_all({ commit, state }, data) {
      return new Promise((resolve, reject) => {
        commit("request");
        axios
          .post(config.api_url + state.endpoint + "/delete_all", data)
          .then(() => {
            commit("success");
            resolve();
          })
          .catch((error) => {
            commit("error");
            reject(error.response.data);
          });
      });
    },
    show({ commit, state }, id) {
      return new Promise((resolve, reject) => {
        commit("request");
        axios
          .get(config.api_url + state.endpoint + "/" + id)
          .then((response) => {
            commit("success");
            // console.log("123123123123 asdasd", response.data);
            resolve(response.data[state.object]);
          })
          .catch((err) => {
            commit("auth_error");
            reject(err);
          });
      });
    },
  },
  getters: {
    status(state) {
      return state.status;
    },
  },
  modules: {},
};
